(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ms-sauna-catalogue-led"]) return;
  try {
    
  const initSaunaCatalogueLed = () => {
    const marker = document.querySelector('[data-ms-sauna-catalogue-led]');
    if (!marker || marker.dataset.msLedInitialized === 'true') return;
    marker.dataset.msLedInitialized = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const svgNamespace = 'http://www.w3.org/2000/svg';
    const ledPath = 'M 5 0.8 Q 0.8 0.8 0.8 5 V 95 Q 0.8 99.2 5 99.2 H 95 Q 99.2 99.2 99.2 95 V 5 Q 99.2 0.8 95 0.8 H 5 Z';
    const createLed = () => {
      const led = document.createElementNS(svgNamespace, 'svg');
      led.classList.add('ms-sauna-card-led');
      led.setAttribute('aria-hidden', 'true');
      led.setAttribute('focusable', 'false');
      led.setAttribute('viewBox', '0 0 100 100');
      led.setAttribute('preserveAspectRatio', 'none');
      led.setAttribute('overflow', 'visible');

      const createPath = () => {
        const path = document.createElementNS(svgNamespace, 'path');
        path.classList.add('ms-sauna-card-led__path');
        path.setAttribute('d', ledPath);
        path.setAttribute('fill', 'none');
        return path;
      };

      const path = createPath();
      led.append(path);
      return { led, path };
    };

    const measureLedPath = (path) => {
      const sourceLength = path.getTotalLength();
      const matrix = path.getScreenCTM();
      if (!sourceLength || !matrix) return;

      const projectPoint = (point) => ({
        x: matrix.a * point.x + matrix.c * point.y + matrix.e,
        y: matrix.b * point.x + matrix.d * point.y + matrix.f,
      });
      const sampleCount = 160;
      let previousPoint = projectPoint(path.getPointAtLength(0));
      let renderedLength = 0;

      for (let index = 1; index <= sampleCount; index += 1) {
        const point = projectPoint(path.getPointAtLength(sourceLength * index / sampleCount));
        renderedLength += Math.hypot(point.x - previousPoint.x, point.y - previousPoint.y);
        previousPoint = point;
      }

      path.style.setProperty('--ms-led-path-length', `${Math.ceil(renderedLength) + 1}px`);
    };

    const ledObserver = !reducedMotion && 'IntersectionObserver' in window
      ? new IntersectionObserver((entries, observer) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('is-ms-led-lit');
            observer.unobserve(entry.target);
          }
        }, { threshold: 0.65, rootMargin: '0px 0px -8% 0px' })
      : null;

    const ledResizeObserver = 'ResizeObserver' in window
      ? new ResizeObserver((entries) => {
          for (const entry of entries) {
            const path = entry.target.querySelector('.ms-sauna-card-led__path');
            if (path) measureLedPath(path);
          }
        })
      : null;

    const decorateCards = () => {
      const cards = document.querySelectorAll('.collection__cards .ms-socle');
      cards.forEach((card) => {
        if (card.dataset.msLedReady === 'true') return;
        const plate = card.querySelector('.ms-socle__plate');
        if (!plate) return;
        card.dataset.msLedReady = 'true';
        const { led, path } = createLed();
        plate.prepend(led);
        measureLedPath(path);
        if (ledResizeObserver) ledResizeObserver.observe(plate);
        if (ledObserver) ledObserver.observe(card);
        else card.classList.add('is-ms-led-lit');
      });
    };

    const collectionRoot = document.querySelector('dynamic-product-search') || document.body;
    const mutationObserver = new MutationObserver(decorateCards);
    mutationObserver.observe(collectionRoot, { childList: true, subtree: true });
    decorateCards();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSaunaCatalogueLed, { once: true });
  } else {
    initSaunaCatalogueLed();
  }

  } catch(e) { console.error(e); }
})();
})();
